module.exports = __webpack_public_path__ + "media/images/terminal-443572ff7eb4d1a5d83cfe87d36c6a14.png";